import { Link } from "react-router-dom";
import Header from "../components/Header";
import { useCookies, withCookies } from "react-cookie";
import Footer from "../components/Footer";

const NotFoundComponent = ({ api }) => {
    const [cookies] = useCookies()
    return (
        <div>
            <Header api={api} />
            <div className="bg-gradient-to-b from-blue-400 to-green-700 text-white h-screen flex items-center justify-center pt-20">
                <div className="text-center space-y-6">
                    {/* Title */}
                    <h1 className="text-5xl md:text-6xl font-extrabold">
                        404
                    </h1>

                    {/* Subtitle */}
                    <p className="text-lg md:text-xl text-gray-200">
                        the page you requested was not found.
                    </p>

                    {/* Call-to-Action Button */}
                    <button className="px-6 py-3 bg-white text-blue-700 font-medium rounded-xl shadow-lg hover:bg-gray-100 transition">
                        <a href={cookies.token ? "/home" : "/splash"}>home</a>
                    </button>

                </div>
            </div>
        </div>
    );
};

const NotFound = withCookies(({ api }) => (
    <div>
        <Header api={api} />
        <NotFoundComponent api={api} />
        <Footer />
    </div>
))

export default NotFound